import {
  COLLECTIONS_LOAD_PROJECT_PLUGINS_BEGIN,
  COLLECTIONS_LOAD_PROJECT_PLUGINS_SUCCESS,
  COLLECTIONS_LOAD_PROJECT_PLUGINS_FAILURE,
  COLLECTIONS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectPlugins(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_PROJECT_PLUGINS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_PLUGINS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_PLUGINS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectPluginsError() {
  return {
    type: COLLECTIONS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_PROJECT_PLUGINS_BEGIN:
      return {
        ...state,
        loadProjectPluginsPending: true,
        loadProjectPluginsError: null,
      };

    case COLLECTIONS_LOAD_PROJECT_PLUGINS_SUCCESS:
      return {
        ...state,
        loadProjectPluginsPending: false,
        loadProjectPluginsError: null,
        plugins: action.data,
      };

    case COLLECTIONS_LOAD_PROJECT_PLUGINS_FAILURE:
      return {
        ...state,
        loadProjectPluginsPending: false,
        loadProjectPluginsError: action.data.error,
      };

    case COLLECTIONS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectPluginsError: null,
      };

    default:
      return state;
  }
}
